/** Resolve display name for admin city records / navigation state. */
export const resolveAdminCityName = cityLike => {
  if (!cityLike) return ""
  if (typeof cityLike === "string") return cityLike.trim()
  return String(cityLike.city || cityLike.name || "").trim()
}

/** Router state payload when navigating into a Manage City screen. */
export const adminCityNavState = city => {
  const name = resolveAdminCityName(city)
  if (!city?.id && !name) return undefined
  return {
    city: {
      id: city?.id,
      name,
      city: name,
      state: city?.state || "",
      country: city?.country || "",
    },
  }
}
